import { BRANDING_GROUPS } from "@/branding/groups";
import { SettingsLayout } from "./SettingsLayout";

export function PlatformSettingsLayout() {
  return (
    <SettingsLayout
      tabs={[
        { to: "/super-admin/settings/security", label: "Security" },
        ...BRANDING_GROUPS.map(({ slug, label }) => ({
          to: `/super-admin/settings/${slug}`,
          label,
        })),
        { to: "/super-admin/settings/whatsapp", label: "WhatsApp" },
      ]}
    />
  );
}
